// extracted by mini-css-extract-plugin
export default {"servicesWrapper":"Services_servicesWrapper__aPAi9","services":"Services_services__2BB12","cards":"Services_cards__mcdEW","card":"Services_card__UOAYH","icon":"Services_icon__JNtS5"};